const createMarkup = (string: string) => {
  return {
    __html: string,
  };
};

export { createMarkup };
